import cbs from '@/images/CBS.svg';
import cnbc from '@/images/CNBC.svg';
import nyt from '@/images/NYT.svg';
import wsj from '@/images/WSJ.svg';
import parents from '@/images/Parents.svg';
import realSimple from '@/images/RealSimple.svg';
import usaToday from '@/images/USAToday.svg';

export interface Size {
  mobile?: number;
  desktop?: number;
}

export interface FeaturedPress {
  logoSrc: string;
  altText: string;
  rowIdx: number;
  multiplier: Size;
}

export const featuredPress: FeaturedPress[] = [
  {
    logoSrc: cbs,
    altText: 'CBS',
    rowIdx: 1,
    multiplier: { desktop: 0.9167 }
  },
  {
    logoSrc: cnbc,
    altText: 'CNBC',
    rowIdx: 1,
    multiplier: {
      mobile: 0.72,
      desktop: 0.67
    }
  },
  {
    logoSrc: nyt,
    altText: 'The New York Times',
    rowIdx: 1,
    multiplier: {
      mobile: 1.4,
      desktop: 1.25
    }
  },
  {
    logoSrc: wsj,
    altText: 'The Wall Street Journal',
    rowIdx: 2,
    multiplier: {
      mobile: 1.4,
      desktop: 0.67
    }
  },
  {
    logoSrc: parents,
    altText: 'Parents',
    rowIdx: 2,
    multiplier: { mobile: 1.4 }
  },
  {
    logoSrc: realSimple,
    altText: 'REALSIMPLE',
    rowIdx: 3,
    multiplier: { mobile: 1.4 }
  },
  {
    logoSrc: usaToday,
    altText: 'USA Today',
    rowIdx: 3,
    multiplier: { mobile: 1.4 }
  }
];
